(() => {
    const destination = document.getElementById('payone-cc-destination');
    const creditCard = document.querySelector('.payone-payment.credit-card');

    if (destination && creditCard) {
        destination.appendChild(creditCard);
    }
})();
